import { render } from "./PremiumFeatured.vue?vue&type=template&id=9dad78fa&scoped=true"
const script = {}

import "./PremiumFeatured.vue?vue&type=style&index=0&id=9dad78fa&scoped=true&lang=css"
import "@/assets/general.scss?vue&type=style&index=1&id=9dad78fa&scoped=true&lang=scss"

import exportComponent from "/home/berkdemiroz/Projects/valenia-web/valenia-web-master/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dad78fa"]])

export default __exports__